import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import SportBrandList from './sport-brands-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Sport Brands">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Sport Brands</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <SportBrandList />
    </Panel>
  );
};

export default Page;
